import {
	salaryInsightTextCategoryCreate,
	salaryInsightTextCategoriesList,
	salaryInsightTextCategoryByID,
	salaryInsightTextCategoryUpdate,
	salaryInsightTextCategoryDestroy,
} from '@/services/jobs/salaryInsightTextCategories.service'

export default {
	namespaced: true,
	state: {
		list: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		item: {},
		listStatus:   'pending',
		saveStatus:   'init',
		deleteStatus: 'init',
	},
	getters: {
		getList(state)         { return state.list },
		getItem(state)         { return state.item },
		getListStatus(state)   { return state.listStatus },
		getSaveStatus(state)   { return state.saveStatus },
		getDeleteStatus(state) { return state.deleteStatus },
	},
	mutations: {
		SET_LIST(state, value)          { state.list = value },
		SET_ITEM(state, value)          { state.item = value },
		SET_LIST_STATUS(state, value)   { state.listStatus = value },
		SET_SAVE_STATUS(state, value)   { state.saveStatus = value },
		SET_DELETE_STATUS(state, value) { state.deleteStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			commit('SET_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await salaryInsightTextCategoriesList(params)
				commit('SET_LIST_STATUS', 'init')
				commit('SET_LIST', data)
				return data
			} catch (error) {
				commit('SET_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchByID({ commit }, id) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await salaryInsightTextCategoryByID(id)
				commit('SET_LIST_STATUS', 'init')
				commit('SET_ITEM', data.data)
				return data
			} catch (error) {
				commit('SET_LIST_STATUS', 'init')
				throw error
			}
		},
		async saveNew({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = await salaryInsightTextCategoryCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SAVE_STATUS', 'init')
				throw error
			}
		},
		async update({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = await salaryInsightTextCategoryUpdate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteByID({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				const { data } = await salaryInsightTextCategoryDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_DELETE_STATUS', 'error')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
	},
}
